import React from 'react';
interface SectionTagProps {
  icon?: string;
  children: React.ReactNode;
}
export function SectionTag({
  icon,
  children
}: SectionTagProps) {
  return <span className="inline-flex items-center gap-2 rounded-full border border-naranja/40 bg-naranja-pale px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-naranja sm:text-sm" data-id="element-264" data-mp="38wkgw3ixv9mq">
      {icon && <span aria-hidden="true" data-id="element-265" data-mp="3iuqgufl6q5oy">{icon}</span>}
      {children}
    </span>;
}